export default __webpack_public_path__ + "static/9-689a98ff0a94865b8b72a08105f5a3fb.webp";